import * as isObject from 'lodash/isObject';

import { LocalStorageKey } from '../enums/local-storage-key.enum';
import { DecoratorUtil } from '../utils/decorator.util';

export function InjectLocalStorage(storageKey: LocalStorageKey, options?: { separator: string }): PropertyDecorator {
	return (target: any, propertyKey: string) => {

		Object.defineProperty(target, propertyKey, {
			set: value => {
				if (value === null) {
					localStorage.removeItem(storageKey);
				} else {
					// check if its a json object
					if (isObject(value)) {
						localStorage.setItem(storageKey, JSON.stringify(value));
					} else {
						localStorage.setItem(storageKey, String(value));
					}
				}
			},
			get: () => {
				const value = localStorage.getItem(storageKey);
				return DecoratorUtil.convertValueToType(target, propertyKey, value, options);
			},
			enumerable: true,
			configurable: true
		});
	};
}
